import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPackagePlans } from '../store/slices/packagePlansSlice';

export const usePackagePlans = (branchId) => {
    const dispatch = useDispatch();
    const { packagePlans, loading, error } = useSelector((state) => state.packagePlans);

    const refetchPackagePlans = () => {
        if (branchId) {
            dispatch(fetchPackagePlans(branchId));
        }
    };

    useEffect(() => {
        if (branchId) {
            dispatch(fetchPackagePlans(branchId));
        }
    }, [dispatch, branchId]);

    return {
        packagePlans,
        loading,
        error,
        refetchPackagePlans
    };
}; 